export enum MeasuredForwardStart {
	FirstUsage = -1,
	FirstUsageSunday = -2
}